/**
 * The name of the native browser `CustomEven
 * ` that is dispatched on `window` whenever
 * a global status message should be shown.
 *
 * Using a native browser event (instead of a redux action) keeps this package free of any
 * dependency on the rest of the Famly app — the producer (these hooks) and the consumer
 * (the global event renderer) are fully decoupled.
 */
export const statusMessageEventName = 'famly/global-status-message';
/**
 * Dispatches a global status message as a native browser `CustomEvent` on `window`.
 *
 * A listener mounted in the app translates this event into the rendered notification.
 *
 * @param detail the status message to show
 */
export function dispatchStatusMessageEvent(detail) {
    window.dispatchEvent(new CustomEvent(statusMessageEventName, { detail }));
}
